"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RETRYABLE_UPLOAD_ERRORS = exports.Routes = void 0;
var Enums_1 = require("../../Core/Http/Enums");
var SERVICE_NAME = 'upload-service';
exports.Routes = {
    GET: "/".concat(SERVICE_NAME, "/uploads/{:id}"),
    GET_CONTENT: "/".concat(SERVICE_NAME, "/uploads/{:id}/content"),
    GET_IMAGE: "/".concat(SERVICE_NAME, "/uploads/{:id}/image"),
    GET_BY_RECORD: "/".concat(SERVICE_NAME, "/uploads/record/{:record_type}/{:record_id}"),
    GET_CONTENT_BY_RECORD: "/".concat(SERVICE_NAME, "/uploads/record/{:record_type}/{:record_id}/content"),
    GET_BATCH: "/".concat(SERVICE_NAME, "/uploads/get_batch"),
    CREATE: "/".concat(SERVICE_NAME, "/uploads"),
    UPDATE: "/".concat(SERVICE_NAME, "/uploads/{:id}"),
    DELETE: "/".concat(SERVICE_NAME, "/uploads/{:id}")
};
/**
 * Uploading files to cloud storage can occasionally result with transient server errors,
 * which are indicated by these status codes.
 *
 * Upon receiving any of these errors, it's up to the client to retry the requests.
 */
exports.RETRYABLE_UPLOAD_ERRORS = Object.freeze([
    Enums_1.HttpStatusCode.INTERNAL_SERVER_ERROR,
    Enums_1.HttpStatusCode.TOO_MANY_REQUESTS,
    Enums_1.HttpStatusCode.SERVICE_UNAVAILABLE
]);
//# sourceMappingURL=upload.consts.js.map